
export const KEY__TABLE_COLLECTION__VIEW_TYPE__COMMON = 'common';
export const KEY__TABLE_COLLECTION__VIEW_TYPE__RECRUITER = 'recruiter';
export const KEY__TABLE_COLLECTION__VIEW_TYPE__CANDIDATE = 'candidate';
export const KEY__TABLE_COLLECTION__VIEW_TYPE__EMPLOYER = 'employer';
export const KEY__TABLE_COLLECTION__VIEW_TYPE__JOB = 'job';
export const KEY__TABLE_COLLECTION__USER_AGREE_TO_TERMS = 'table_collection__user_agree_to_terms';
